import api from './client';

// Phase 43 · Creator Onboarding wizard API client.
// Backs the multi-step /creator/onboarding UI.

export const getOnboardingState = async () => {
  const res = await api.get('/creator/onboarding');
  return res.data;
};

export const saveOnboardingStep = async ({ step, fiscal }) => {
  const res = await api.put('/creator/onboarding/step', {
    step,
    ...(fiscal ? { fiscal } : {}),
  });
  return res.data;
};

export const submitOnboarding = async () => {
  const res = await api.post('/creator/onboarding/submit');
  return res.data;
};

// Phase 90 · Creator activation decoupled from Stripe.

export const getActivationStatus = async () => {
  const res = await api.get('/creator/activation-status');
  return res.data;
};

export const sendPhoneOtp = async (phone) => {
  const res = await api.post('/creator/phone/send-otp', { phone });
  return res.data;
};

export const verifyPhoneOtp = async (phone, code) => {
  const res = await api.post('/creator/phone/verify-otp', { phone, code });
  return res.data;
};

export const acceptCreatorAgreement = async () => {
  const res = await api.post('/creator/agreement/accept');
  return res.data;
};

export const activateCreator = async () => {
  const res = await api.post('/creator/activate');
  return res.data;
};
